import styled from 'styled-components'
import { SCREEN_SIZE } from '../../../../lib/Media'

export const Field = styled.div`
  display: block;
  border: ${props => (props.borderless ? 'none' : 'solid 1px #eaeaea')};
  border-radius: 4px;
  padding: 1rem;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  color: #333;
  cursor: pointer;

  label {
    cursor: pointer;
  }
  label span {
    font-weight: 400;
    ${SCREEN_SIZE.From.Desktop} {
      font-size: 1rem;
    }
  }
  a {
    text-decoration: none;
    font-weight: 600;
  }
`

export const ErrorText = styled.div`
  margin-top: 0.25rem;
  padding-left: 1.6rem;
  color: #dd0d42;
  font-weight: 600;
`
